import React from 'react'
import { Modal } from 'react-bootstrap'
import ModalBody from 'react-bootstrap/ModalBody'
import ModalHeader from 'react-bootstrap/ModalHeader'
import ModalTitle from 'react-bootstrap/ModalTitle'
import ModalFooter from 'react-bootstrap/ModalFooter'
import { Button, IconButton } from '@mui/material'
import CloseIcon from '@mui/icons-material/Close'
import cx from 'classnames'

import { useTranslation } from 'react-i18next'

export default function ConfirmationModal(props: any) {
  const { t } = useTranslation('translation')
  return (
    <Modal
      show={props.show}
      size={props.size}
      aria-labelledby="contained-modal-title-vcenter"
      centered
      dialogClassName={
        props.dialogClassName
          ? props.dialogClassName
          : 'delete-knowledge-confirmation'
      }
    >
      <ModalHeader
        className={cx({
          'pt-3': true,
          'justify-content-between': props.headerMessage ? true : false,
        })}
        onHide={props.onHide}
      >
        {props.headerMessage && (
          <ModalTitle id="contained-modal-title-vcenter">
            {props.headerMessage}
          </ModalTitle>
        )}
        <IconButton onClick={props.onHide} size="small">
          <CloseIcon />
        </IconButton>
      </ModalHeader>
      <ModalBody>
        <div className="px-4">{props.message}</div>
      </ModalBody>
      <ModalFooter className="border-0 justify-content-center px-3 mb-3 mx-4 flex-nowrap">
        <Button
          variant="outlined"
          color="primary"
          sx={{ flex: 1, textTransform: 'none', mr: 1.5 }}
          onClick={
            props.confirmOnHideHandler
              ? props.confirmOnHideHandler
              : props.onHide
          }
        >
          {props.secondaryButtonText
            ? props.secondaryButtonText
            : t('No, Cancel')}
        </Button>
        <Button
          variant="contained"
          color={props.positiveAction ? 'primary' : 'error'}
          sx={{ flex: 1, textTransform: 'none', ml: 1.5 }}
          onClick={e => props.confirmHandler(e)}
        >
          {props.buttonText ? props.buttonText : t('Yes, Delete')}
        </Button>
      </ModalFooter>
    </Modal>
  )
}
